import type { SearchParamsObject } from '@algolia/client-search';

import type { I18nFn } from '#/i18n/types/I18nFn';
import { I18N_LOCALES } from '#/i18n/types/I18nLocale';
import { searchAlgoliaOptionsFiltersForFacets } from '#/modules/search/algolia/options/searchAlgoliaOptionsFiltersForFacets';
import { unstableInternshipSearchFacets } from '#/modules/search/constants/useSearchFacetsInternship';
import type { SearchFiltersById } from '#/modules/search/types/SearchFiltersById';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';
import { algoliaQueryStringFilter } from '#/utils/algolia/helpers/algoliaQueryStringFilter';
import { SEARCH_PAGE_SIZE } from '#/utils/constants/general/searchPageSize';

const attributesToRetrieve = [
  'objectID',
  'type',
  'published',
  'name',
  'city',
  'state',
  'stateStr',
  'country',
  'url',
  'orgID',
  'orgUrl',
  'orgName',
  'orgType',
  'jobType',
  'logo',
  'locationType',
  'remoteCountry',
  'remoteState',
  'remoteZone',
  'paid',
  'payment',
  '_geoloc',
  'hasPublishedListings',
  'actionType',
  'source',
  'timezone',
  'hasAts',
  'isPostedAnonymously',
  'hiring',
  'salaryMinimum',
  'salaryMaximum',
  'salaryCurrency',
  'salaryPeriod',
];

type Args = {
  i18n: I18nFn;
  filtersById: SearchFiltersById;
  searchLocation: SearchLocation | undefined;
};

export function searchAlgoliaInternshipsOptions({
  i18n,
  filtersById,
  searchLocation,
}: Args): SearchParamsObject {
  return {
    facets: ['*'],
    hitsPerPage: SEARCH_PAGE_SIZE,
    attributesToSnippet: ['description:20'],
    attributesToRetrieve,
    filters: [
      algoliaQueryStringFilter('type', 'INTERNSHIP'),
      ...searchAlgoliaOptionsFiltersForFacets({
        filtersById,
        searchFacets: unstableInternshipSearchFacets(i18n),
        searchLocation,
      }),
    ].join(' AND '),
    removeStopWords: true,
    ignorePlurals: true,
    advancedSyntax: true,
    queryLanguages: I18N_LOCALES,
  } satisfies SearchParamsObject;
}
